import Page from "webPage/Page";
import Track from "util/Track";
window.$ = window.jQuery;

Page.register('post-template-default', () => {

    new Track($('.js-gallery-wrap'), {
        classes: {
            block: "slider",
        },
    });
});